import React from 'react';
import { Countdown } from './Countdown';
const CLAIMED_PERCENT = 68;
export function LaunchUrgency() {
  return <section aria-labelledby="urgency-heading" className="bg-wood-dark py-12 sm:py-20" data-id="element-156" data-mp="mfwwmerhwptg">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-157" data-mp="11645c2rpaugy">
        <div data-id="element-158" data-mp="w7supptl0fxo">
          <p className="text-[10px] font-semibold uppercase tracking-label text-gold sm:text-[11px]" data-id="element-159" data-mp="w79o359dtdyy">
            Limited-time offer
          </p>
          <h2 id="urgency-heading" className="mt-4 font-display text-2xl leading-tight text-paper sm:text-4xl" data-id="element-160" data-mp="3ic50zxcjd55">
            Launch pricing expires in
          </h2>
          <div className="mt-6" data-id="element-161" data-mp="dgi5dd3i8b7w">
            <Countdown initialSeconds={86347} tone="light" data-id="element-162" data-mp="df7018ueuveo" />
          </div>
          <p className="mt-6 max-w-md text-sm text-paper-400" data-id="element-163" data-mp="1swh98c639l2c">
            Launch pricing ends today. After that, pricing returns to $97.
          </p>
        </div>

        <div className="border border-wood-light bg-noir-800 p-5 sm:p-7" data-id="element-164" data-mp="1oxro1xet6z85">
          <div className="flex items-baseline justify-between gap-4" data-id="element-165" data-mp="1yi531vcc8jio">
            <span className="text-[10px] font-semibold uppercase tracking-label text-paper-400 sm:text-[11px]" data-id="element-166" data-mp="23gyhbpzg8ejw">
              Limited availability &mdash; today only
            </span>
            <span className="font-display text-2xl font-semibold leading-none text-gold" data-id="element-167" data-mp="2ciy12q1ulwqj">
              {CLAIMED_PERCENT}%
            </span>
          </div>
          <div className="mt-5 h-2 w-full bg-wood" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Launch allocation claimed" data-id="element-168" data-mp="1fq2l8gnymx6u">
            <div className="h-full bg-gold" style={{
            width: `${CLAIMED_PERCENT}%`
          }} data-id="element-169" data-mp="1tklpkxngsars" />
          </div>
          <p className="mt-4 text-xs uppercase tracking-label text-paper-400" data-id="element-170" data-mp="w3eodygk2e69">Claimed</p>
        </div>
      </div>
    </section>;
}